import { render } from "./BaseDateRangePicker.vue?vue&type=template&id=6664a0c3&scoped=true"
import script from "./BaseDateRangePicker.vue?vue&type=script&lang=js"
export * from "./BaseDateRangePicker.vue?vue&type=script&lang=js"

import "./BaseDateRangePicker.vue?vue&type=style&index=0&id=6664a0c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6664a0c3"]])

export default __exports__